import { DataTypeContent } from '@efdigital/ll-addon-data/data-types';
import type { Page } from '@efdigital/ll-addon-data/types/content/page';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { cacheKeyFor, type Store } from '@warp-drive/core';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import {
  createRecord,
  findRecord,
  serializePatch,
  updateRecord,
} from '@warp-drive/utilities/json-api';

/**
 * Finds a page by id
 * @param pageId - The id of the page to find
 * @returns JSON API request to find the page
 */
export function findPageWithContent(pageId: string) {
  return findRecord<Page>(DataTypeContent.Page, pageId, {
    ...jsonApiOptions,
    include: [
      'quizzes',
      'readinglists',
      'readinglists.resources',
      'readinglists.resources.contacts',
      'files',
      'folders',
      'folders.files',
      'folders.folders',
      'calendarItems',
      'calendarItems.contacts',
      'calendarItems.files',
    ],
  } as FindRecordOptions);
}

export function createPage(page: Page, store: Store) {
  const init = createRecord(page, {
    ...jsonApiOptions,
  });

  init.body = JSON.stringify({
    data: store.cache.peek(cacheKeyFor(page)),
  });

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}

export function updatePage(page: Page, store: Store) {
  const init = updateRecord(page, {
    ...jsonApiOptions,
    patch: true,
  });

  init.body = JSON.stringify(serializePatch(store.cache, cacheKeyFor(page)));

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}
